const handler = tracker => ({
  trackBudgeAvailability: metadata => {
    tracker().trackEvent("Ha abierto la pestaña de disponibilidad presupuestal", metadata)
  }
})

export default handler